import React, { createContext, useState } from "react";

const initialAppState = {
  organizationSymbol: process.env.REACT_APP_ORGANIZATION_SYMBOL,  
  app_stage: process.env.REACT_APP_STAGE,
  react_app_api_url: process.env.REACT_APP_API_URL,
  react_app_frontend_url: process.env.REACT_APP_FRONTEND_URL
};

export const AppContext = createContext({
  state: initialAppState,
  setContext: () => {}
});

export const AppProvider = ({ children }) => {
  const [state, setState] = useState(initialAppState);

  const setContext = updates => {
    setState(prev => ({
      ...prev,
      ...updates
    }));
  };

  return (
    <AppContext.Provider value={{ state, setContext }}>
      {children}
    </AppContext.Provider>
  );
};